import { useEffect, useState } from 'react';

export default function useGetMarkdownFile(
  setError: (isError: boolean) => void,
  markdownFilePath: string,
) {
  const [markdownTextState, setMarkdownText] = useState('');
  useEffect(() => {
    import(`src//resource/${markdownFilePath}.md`)
      .then((importResult) => {
        fetch(importResult.default)
          .then((fetchResult) => fetchResult.text())
          .then((markdownText) => setMarkdownText(markdownText))
          .catch(() => {
            setError(true);
          });
      })
      .catch(() => {
        setError(true);
      });
  }, []);
  return markdownTextState;
}
